import AuthModal, { AuthModalFormData } from './AuthModal';

export type { AuthModalFormData };
export default AuthModal;
